import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { formatIvTooltip } from '../../../utils/dataSourceTooltip';
import { describeSize } from '../../../utils/straddleCalculations';

export const TIP_COST = 'cost';
export const TIP_IV = 'iv';
export const TIP_QUALITY = 'quality';

/**
 * Marks an element as having row hover text. Carries only which row and which text,
 * not the text itself, because formatting it for every row on every slider move is
 * what made large tables slow.
 */
export const rowTip = (tooltipId, row, kind, side) => ({
  'data-tooltip-id': tooltipId,
  'data-tip-row': row._key,
  'data-tip-kind': kind,
  ...(side ? { 'data-tip-side': side } : {}),
});

/** The hover text for one row. Runs only when that element is actually hovered. */
export function rowTipText(row, kind, side) {
  switch (kind) {
    case TIP_COST:
      return describeSize(row);
    case TIP_IV:
      return formatIvTooltip(row._legs?.[side]?._meta?.implied_volatility);
    case TIP_QUALITY: {
      const notes = [...(row['Quality Notes'] || [])];
      if (row['Round-Trip Spread %'] != null) {
        notes.push(`Crossing both spreads in and out costs ${Number(row['Round-Trip Spread %']).toFixed(2)}% of the debit`);
      }
      if (row._modelGap) notes.push("Today's model value misses the quote by over 10%, so the 0% column may mislead");
      return notes.join('\n');
    }
    default:
      return null;
  }
}

/** One tooltip serving every `rowTip` element in a table, looking its row up on hover. */
function StraddleRowTooltip({ id, rowsByKey, style }) {
  return (
    <ReactTooltip
      id={id}
      place="top"
      delayShow={300}
      style={style}
      render={({ activeAnchor }) => {
        const row = activeAnchor && rowsByKey.get(activeAnchor.getAttribute('data-tip-row'));
        if (!row) return null;
        return rowTipText(
          row,
          activeAnchor.getAttribute('data-tip-kind'),
          activeAnchor.getAttribute('data-tip-side'),
        ) || null;
      }}
    />
  );
}

export default StraddleRowTooltip;
